export const radioHelpData = [
  {
    bubbleOpacity: 0,
    className: 'bubble-1',
    message: 'выключить звук',
  },
  {
    bubbleOpacity: 0,
    className: 'bubble-2',
    message: 'двигай указатель частоты',
  },
  {
    bubbleOpacity: 0,
    className: 'bubble-3',
    message: 'крути, чтобы выбрать частоту',
  },
  {
    bubbleOpacity: 0,
    className: 'bubble-4',
    message: 'кликни на год чтобы открыть страницу программы',
  },
]

export const videoHelpData = [
  {
    bubbleOpacity: 0,
    className: 'bubble-video-1',
    message: 'Кликни на экран, чтобы развернуть видео',
  },
  {
    bubbleOpacity: 0,
    className: 'bubble-video-2',
    message: 'Переключай каналы здесь',
  }
]
